var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGiftOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:gift"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.12909 5.00003C6.92636 4.99355 5.75545 6.17242 6.29 7.63629H4.27273C3.93518 7.63629 3.61146 7.77278 3.37277 8.01573C3.13409 8.25867 3 8.58818 3 8.93176V10.2272C3 10.399 3.06705 10.5638 3.18639 10.6852C3.30573 10.8067 3.46759 10.875 3.63636 10.875H9.36364H10.6364H16.3636C16.5324 10.875 16.6943 10.8067 16.8136 10.6852C16.933 10.5638 17 10.399 17 10.2272V8.93176C17 8.58818 16.8659 8.25867 16.6272 8.01573C16.3885 7.77278 16.0648 7.63629 15.7273 7.63629H13.71C14.4545 5.51821 11.6545 4.02195 10.3627 5.84855L10 6.34083L9.63727 5.8356C9.23636 5.25912 8.68273 5.0065 8.12909 5.00003ZM8.09091 6.34083C8.65727 6.34083 8.94364 7.04038 8.54273 7.44845C8.14182 7.85652 7.45455 7.56504 7.45455 6.98856C7.45455 6.81677 7.52159 6.65202 7.64093 6.53055C7.76027 6.40907 7.92213 6.34083 8.09091 6.34083ZM11.9091 6.34083C12.4755 6.34083 12.7618 7.04038 12.3609 7.44845C11.96 7.85652 11.2727 7.56504 11.2727 6.98856C11.2727 6.81677 11.3398 6.65202 11.4591 6.53055C11.5785 6.40907 11.7403 6.34083 11.9091 6.34083ZM3.63636 11.5227V16.7045C3.63636 17.0481 3.77045 17.3776 4.00914 17.6206C4.24782 17.8635 4.57154 18 4.90909 18H15.0909C15.4285 18 15.7522 17.8635 15.9909 17.6206C16.2295 17.3776 16.3636 17.0481 16.3636 16.7045V11.5227H10.6364H9.36364H3.63636Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGiftOutline);
export default __webpack_public_path__ + "static/media/icon-gift-outline.d6d48c6d955df3dfd1fc1cb7398e30b0.svg";
export { ForwardRef as ReactComponent };